module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/2@2x_67e043636005f08320e9c2a021f95d1c.png";